import { useModelApi, UseModelApiProps } from '@melio/api-client';
import { SubscriptionsApiClient } from '@melio/platform-api-axios-client';

import { SubscriptionPreview } from './types';

type QueryFn = typeof SubscriptionsApiClient.getSubscriptionsPreview;

export type UseSusbscriptionsPreviewProps = UseModelApiProps<
  typeof SubscriptionsApiClient.getSubscriptionsPreview,
  SubscriptionPreview
>;

export const useSubscriptionsPreview = (props: UseSusbscriptionsPreviewProps = {}) =>
  useModelApi<QueryFn, never, never, never, SubscriptionPreview>({
    ...props,
    queryKey: ['SubscriptionsApi', 'preview'],
    queryFn: SubscriptionsApiClient.getSubscriptionsPreview,
  });
